<template>
  <div class="yt-school-list">
    <GridTable
      ref="gridTable"
      id="SchoolList"
      :title="title"
      urlPath="schoolsCms"
      :columns="columns"
      :schema="schema"
      :afterSaveHook="afterSaveHook"
      :defaultServerParams="{
        _fields: '_id,name,domain,isActive,totalTutors,totalStudents,createdAt',
        _sort: 'createdAt',
        _order: 'desc'
      }"
    >
      <template v-slot:customButtons="slotProps">
        <router-link
          :to="{
            name: 'SubjectList',
            query: { schoolId: slotProps.props.row._id }
          }"
          class="btn btn-success"
          >Subjects</router-link
        >
      </template>
    </GridTable>
  </div>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import VueFormGenerator from 'vue-form-generator'

import AccessMixin from '@/lib/mixins/access'
import GridTable from '@/components/common/GridTable'

const appModule = namespace('app')

@Component({
  components: {
    GridTable
  },
  mixins: [AccessMixin]
})
export default class SchoolList extends Vue {
  @appModule.State('baseUrl') baseUrl
  @appModule.Action('getSchools') actionGetSchools

  title = 'Schools'

  columns = [
    {
      label: 'ID',
      field: '_id',
      hidden: true
    },
    {
      label: 'Name',
      field: 'name',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by Name', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    {
      label: 'Domain',
      field: 'domain',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by Domain', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    {
      label: 'Active',
      field: 'isActive',
      type: 'switch'
    },
    {
      label: '# Students',
      field: 'totalStudents',
      type: 'number'
    },
    {
      label: '# Tutors',
      field: 'totalTutors',
      type: 'number'
    },
    {
      label: 'Member Since',
      field: 'createdAt',
      type: 'date',
      dateInputFormat: 'YYYY-MM-DD', // expects 2018-03-16
      dateOutputFormat: 'MMM Do YYYY', // outputs Mar 16th 2018
      sortable: true
    },
    {
      label: 'Actions',
      field: 'actions'
    }
  ]

  schema = {
    fields: [
      {
        // label: 'ID (disabled text field)',
        model: '_id',
        type: 'input',
        inputType: 'hidden',
        readonly: true
        // disabled: true
      },
      {
        label: 'Name',
        model: 'name',
        type: 'input',
        inputType: 'text',
        placeholder: 'School name',
        required: true,
        validator: VueFormGenerator.validators.string.locale({
          // fieldIsRequired: 'The name is required!'
        })
      },
      {
        label: 'Domain',
        model: 'domain',
        type: 'input',
        inputType: 'text',
        placeholder: 'School domain url',
        required: true,
        validator: VueFormGenerator.validators.string.locale({
          // fieldIsRequired: 'The name is required!'
        })
      },
      {
        label: 'Active',
        model: 'isActive',
        type: 'switch',
        default: false,
        textOn: 'Active',
        textOff: 'Inactive'
      },
      {
        label: 'Address 1',
        model: 'address1',
        type: 'input',
        inputType: 'text',
        placeholder: '',
        validator: VueFormGenerator.validators.string
      },
      {
        label: 'Address 2',
        model: 'address2',
        type: 'input',
        inputType: 'text',
        placeholder: '',
        validator: VueFormGenerator.validators.string
      },
      {
        label: 'City',
        model: 'city',
        type: 'input',
        inputType: 'text',
        placeholder: '',
        validator: VueFormGenerator.validators.string
      },
      {
        label: 'State',
        model: 'state',
        type: 'select',
        featured: true,
        required: true,
        validator: VueFormGenerator.validators.required.locale({
          fieldIsRequired: 'State is required!'
        })
      },
      {
        label: 'Zip Code',
        model: 'zipCode',
        type: 'input',
        inputType: 'text',
        placeholder: '',
        validator: ['zipcodeValidator']
      },
      {
        type: 'YTDate',
        label: 'Students Activation Date',
        model: 'studentsInactivationDate',
        required: true,
        dateTimePickerOptions: {
          format: 'YYYY-MM-DD'
        },
        validator: ['required']
      },
      {
        label: 'Contact Name',
        model: 'contactName',
        type: 'input',
        inputType: 'text',
        placeholder: '',
        validator: VueFormGenerator.validators.string
      },
      {
        label: 'Contact Phone',
        model: 'contactPhone',
        type: 'input',
        inputType: 'text',
        placeholder: '',
        validator: VueFormGenerator.validators.string
      },
      {
        label: 'Contact Email',
        model: 'contactEmail',
        type: 'input',
        inputType: 'text',
        placeholder: '',
        validator: VueFormGenerator.validators.string
      }
    ]
  }

  created() {
    this.getStates()
  }

  getStates() {
    this.$http
      .get(`${this.baseUrl}states`, {
        params: {
          _fields: '_id,code'
        }
      })
      .then(response => {
        const states = response.data.result.map(item => {
          return { id: item._id, name: item.code }
        })

        const stateSchema = this.schema.fields.find(
          item => item.model === 'state'
        )

        stateSchema.values = function() {
          return states
        }

        stateSchema.default = states && states[0] ? states[0].id : ''
      })
      .catch(error => {
        console.warn(error)
      })
  }

  afterSaveHook() {
    this.actionGetSchools()
  }

  /* async getStates () {
        let states = []

        const promise = new Promise((resolve, reject) => {
            this.$http.get(`${baseUrl}states`, {
                params: {
                    _fields: '_id,name'
                }
            }).then(response => {
                const list = response.data.result.map((item) => {
                    return { id: item._id, name: item.code }
                })
                resolve(list)
            }).catch(error => {
                reject(error)
                console.warn(error)
            })
        })

        states = await promise

        console.log('states', states)

        return states
    } */
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/schools/SchoolList.vue